import { AnalyticsCard } from '../../../../../ui/components';
import { useCredentialingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { licenseCheckAnalyticsCardStatuses } from '../../types';
import { getLicenseCheckAnalyticsCardIcon, licenseCheckAnalyticsFilterMap } from '../../utils/licenseCheckAnalyticsUtils';
export const LicenseCheckAnalyticsGroupList = ({ title, credentialType, analytics, onCardClick }) => {
    const [t] = useCredentialingTranslation();
    return (React.createElement(Stack, { sx: { width: '100%' }, gap: 2 },
        React.createElement(Paper, { elevation: 0, sx: {
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid ' + themeColors.border.main,
                borderRadius: 2,
            } },
            React.createElement(Stack, { direction: 'row', sx: { p: 2, justifyContent: 'space-between', alignItems: 'center' } },
                React.createElement(Typography, { variant: 'subtitle2' }, title)),
            React.createElement(Stack, { gap: 2, direction: 'row', sx: { p: 2, width: '100%', flexWrap: 'wrap' } }, licenseCheckAnalyticsCardStatuses.map((cardStatus) => {
                var _a;
                return (React.createElement(AnalyticsCard, { key: cardStatus, icon: getLicenseCheckAnalyticsCardIcon(cardStatus), headingColor: 'main', headingText: t(`licenseCheckAnalyticsWidget.${cardStatus}`), content: (_a = analytics === null || analytics === void 0 ? void 0 : analytics[cardStatus]) !== null && _a !== void 0 ? _a : 0, "data-test": `${cardStatus}-card-${credentialType}`, onClick: () => onCardClick(licenseCheckAnalyticsFilterMap[cardStatus]), footerText: cardStatus === 'verified' && (analytics === null || analytics === void 0 ? void 0 : analytics.verifiedExpiring)
                        ? t('licenseCheckAnalyticsWidget.expiringSoon', { quantity: analytics.verifiedExpiring })
                        : undefined }));
            })))));
};
